import { Icon, useOpenClose } from "@evertrue/et-components";
import RecentGiftRecommendedActions from "./sections/recent-gift-recommended-actions";
import BirthdayRecommendedActions from "./sections/birthday-recommended-actions";
import GiftAnniversaryRecommendedActions from "./sections/gift-anniversary-recommended-actions";
import RecommendedActionUserSettingsModal from "./recommendation-settings-modal";
import HomepageCard from "../homepage-card";
import MoveToJourneyModal from "../../modals/move-to-journey-modal";
import { useRecommendedActionsProvider } from "apps/journeys/components/home-page/recommended-actions/context/recommended-actions-context";

const RecommendedActions = () => {
  const {
    enableGiftSection = true,
    enableBirthdaySection = true,
    enableAnniversarySection = true,
    giftAmount = 0,
  } = useRecommendedActionsProvider();

  const [isMoveToJourneyModalOpen, openMoveToJourneyModal, closeMoveToJourneyModal] = useOpenClose();
  const [isRecommendationsModalOpen, openRecommendationsModal, closeRecommendationsModal] = useOpenClose();

  return (
    <>
      <h1 className="homepage-card-title">Your Assigned Constituents</h1>
      <HomepageCard
        leftHeading={
          <span className="homepage-recommendations-card-left">
            Recommended Actions
            <span className="homepage-recommendations-card-subtitle">
              Here are your assigned constituents with whom we recommend establishing a touchpoint.
            </span>
          </span>
        }
        rightHeading={
          <>
            <Icon icon="more-vert" size={1} onClick={openMoveToJourneyModal} className="homepage-settings-icon" />
            <Icon icon="gear" size={1} onClick={openRecommendationsModal} className="homepage-settings-icon" />
          </>
        }
        body={
          <div>
            {enableGiftSection && <RecentGiftRecommendedActions enabled={enableGiftSection} giftAmount={giftAmount} />}
            {enableBirthdaySection && <BirthdayRecommendedActions enabled={enableBirthdaySection} />}
            {enableAnniversarySection && <GiftAnniversaryRecommendedActions enabled={enableAnniversarySection} />}
          </div>
        }
      />
      <MoveToJourneyModal
        contact={{}} // not real yet
        isOpen={isMoveToJourneyModalOpen}
        onClose={closeMoveToJourneyModal}
        title="Add To Cadence"
      />
      <RecommendedActionUserSettingsModal isOpen={isRecommendationsModalOpen} onClose={closeRecommendationsModal} />
    </>
  );
};

export default RecommendedActions;
